import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-widget-content-gutters>` adds 16px left and right padding for widget content
 */
@Component({
  selector: 'labs-widget-content-gutters',
  template: '<ng-content></ng-content>',
  styleUrls: ['./widget-content-gutters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetContentGuttersComponent {}
